import React from "react";
import UiTag from "./UiTag";
import styles from "./UiTablePage.module.css";

const UiTableCardHeader = ({
  title,
  subtitle,
  count,
  countSuffix = "services",
  extra,
  className,
}) => {
  if (!title && !subtitle && !extra) return null;

  return (
    <header
      className={[styles.tableCardHeader, className].filter(Boolean).join(" ")}
    >
      <div className={styles.tableCardHeaderMain}>
        {title ? (
          <div className={styles.tableCardTitleRow}>
            <h3 className={styles.tableCardTitle}>{title}</h3>
            {count != null && count !== "" ? (
              <UiTag tone="info" size="sm">
                {count} {countSuffix}
              </UiTag>
            ) : null}
          </div>
        ) : null}
        {subtitle ? (
          <p className={styles.tableCardSubtitle}>{subtitle}</p>
        ) : null}
      </div>
      {extra ? <div className={styles.tableCardHeaderExtra}>{extra}</div> : null}
    </header>
  );
};

export default UiTableCardHeader;
